import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/styles';
import * as React from 'react';
import { default as Theme } from '../../theme/fm-theme';

const useStyles = makeStyles((theme: Theme) => ({
    root: theme?.custom?.loading?.root || {},
    transparentRoot: { ...theme.custom?.loading.transparentRoot },
}));

interface LoadingProps {
    width?: number | string;
    height?: number | string;
    transparent?: boolean;
}
export function Loading(props: LoadingProps): JSX.Element {
    let { width = '100%', height = '100%', transparent = false } = props;

    const classes = useStyles();

    let className = transparent ? classes.transparentRoot : classes.root;
    return (
        <div className={className} style={{ width, height }}>
            <CircularProgress />
        </div>
    );
}

export default Loading;
